export default __webpack_public_path__ + "static/media/challenge_7.2bfd3232.svg";